
import DirectboxDefault from "../../../assets/outline/DirectboxDefault.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectboxDefaultIcon({ className, dataTestid = "DirectboxDefaultIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectboxDefault data-testid={dataTestid} className={classes} {...rest} />
  );
}
